import './product-recommendations.scss';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initProductRecommendations = (context) => {
  const productRecommendationsSection = context.closest('.shopify-section');
  if (!productRecommendationsSection) return;

  const container = productRecommendationsSection.querySelector(
    '.product-recommendations__container',
  );
  if (
    !container ||
    container?.dataset?.productsOrigin === 'metafield' ||
    !window?.dAgency?.recommendations
  )
    return;

  fetch(
    `${window.dAgency.recommendations.url}?section_id=${window.dAgency.recommendations.sectionId}&product_id=${window.dAgency.recommendations.productId}&limit=${window.dAgency.recommendations.productsLimit}`,
  )
    .then((res) => {
      if (!res.ok) throw new Error(res.status);
      return res.text();
    })
    .then((data) => {
      const temp = new DOMParser()
        .parseFromString(data, 'text/html')
        .querySelector('.product-recommendations__container');
      if (!temp) return;
      container.innerHTML = temp.innerHTML;
      const carouseBanner = container.querySelector(
        '.carousel-banner__container',
      );

      if (
        carouseBanner &&
        typeof window.dAgency.initCarouselBanner !== 'undefined'
      ) {
        window.dAgency.initCarouselBanner(carouseBanner);
        container.removeAttribute('data-products-origin');
      }
    })
    .catch((err) => {
      throw err;
    });
};

if (document.readyState != 'loading') {
  [].forEach.call(
    document.querySelectorAll('.product-recommendations__container'),
    (el) => {
      window.dAgency.initProductRecommendations(el);
    },
  );
} else {
  document.addEventListener('DOMContentLoaded', () => {
    [].forEach.call(
      document.querySelectorAll('.product-recommendations__container'),
      (el) => {
        window.dAgency.initProductRecommendations(el);
      },
    );
  });
}
